module.exports = __webpack_public_path__ + "static/media/kids_14.f097d346.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_14.jpg
// module id = 5870
// module chunks = 0